import { MarkerClusterer } from "@googlemaps/markerclusterer";
declare global {
  interface Window {
    initMapLieux: () => void;
    mapLieuxData: {
      customIconUrl: string;
      lieux: Array<{
        title: string;
        lat: number;
        lng: number;
        address: string;
        city: string;
        types: Array<string>;
        categories: Array<string>;
        image: string;
        link: string
      }>;
    };
  }
}
class BlockArchiveLieux {

  private lieux: any[] = [];
  private lastInfoWindow: google.maps.InfoWindow | null = null;
  private googleMap!: google.maps.Map;
  private markers: Array<{ marker: google.maps.marker.AdvancedMarkerElement; types: string[]; categories: string[], city: string }> = [];
  private customRenderer: any;
  private markersCluster: MarkerClusterer | null = null;

  constructor() {
    window.initMapLieux = this._init.bind(this);
  }

  async _init() {
    this.lieux = window.mapLieuxData?.lieux;
    if (typeof this.lieux !== 'undefined' && this.lieux.length > 0) {
      const mapElement = document.querySelector(".archive-lieux__map") as HTMLElement;

      if (!mapElement) return;

      // Charger dynamiquement les bibliothèques "maps" et "marker"
      const { Map } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
      const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;

      // Initialiser la carte
      this.googleMap = new Map(mapElement, {
        zoom: 15,
        center: { lat: this.lieux[0].lat, lng: this.lieux[0].lng },
        mapId: 'Carte Lieux',
      });

      // Création des marqueurs
      this._initMarkers(AdvancedMarkerElement);

      // Clustering des marqueurs
      this._customRendererMarkerCluster(AdvancedMarkerElement);
      this._initMarkersCluster();

      // Centrer la carte sur tous les marqueurs après ajout
      this._centerMap()

      // Filtrage
      this._filters();

      // Reset
      // this._reset();

    }
  }

  _initMarkers(AdvancedMarkerElement) {
    this.markers = this.lieux.map(lieu => {

      const iconImg = document.createElement('img');
      iconImg.src = window.mapLieuxData?.customIconUrl;;
      const marker = new AdvancedMarkerElement({
        position: { lat: lieu.lat, lng: lieu.lng },
        map: this.googleMap,
        title: lieu.title,
        content: iconImg,
      });


      // Création de l'infoWindow
      const content = this._buildContent(lieu);

      const infoWindow = new google.maps.InfoWindow({
        content: content
      });

      marker.addEventListener('click', () => {
        // Si un autre infowindow est ouvert, on le ferme
        if (this.lastInfoWindow) {
          this.lastInfoWindow.close();
        }
        infoWindow.open(this.googleMap, marker);
        // Mettre à jour la référence au dernier infowindow ouvert
        this.lastInfoWindow = infoWindow;
      });

      return {
        marker: marker,
        types: lieu.types,
        categories: lieu.categories,
        city: lieu.city
      };;
    });

  }

  _buildContent(lieu) {
    return `
    <div class="archive-lieux__infos">
      <div class="archive-lieux__infos-text">
        <h2 class="archive-lieux__infos-title">
          ${lieu.title}
        </h2>
        <div class="archive-lieux__infos-address">
          ${lieu.address}
        </div>
        <a 
          href="${lieu.link}" 
          target="_blank" 
          class="btn"
        >
          Consulter
        </a>
      </div>
      <img class="archive-lieux__infos-image"
        src="${lieu.image}" 
        alt="${lieu.title}" 
      />
    </div>
  `
  }

  _centerMap() {
    const bounds = new google.maps.LatLngBounds();

    this.markers.forEach((marker) => {
      const position = marker.marker.position;
      if (position && marker.marker.map !== null) {
        bounds.extend(position);
      }
    });

    // Si des marqueurs sont visibles, centrer la carte sur ces marqueurs
    if (!bounds.isEmpty()) {
      this.googleMap.fitBounds(bounds);
    }
  }

  _customRendererMarkerCluster(AdvancedMarkerElement) {
    // Définir un renderer personnalisé pour les clusters
    this.customRenderer = {
      render: ({ count, position }: { count: number; position: google.maps.LatLng }) => {
        const svg = `
    <svg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="20" fill="#c74f2e" />
      <text x="50%" y="50%" text-anchor="middle" dy=".3em" font-size="14px" fill="white">
        ${count}
      </text>
    </svg>`;

        // Utiliser AdvancedMarkerElement pour afficher les clusters
        return new AdvancedMarkerElement({
          position,
          content: (() => {
            const div = document.createElement("div");
            div.innerHTML = svg;
            return div;
          })(),
        });
      },
    };
  }


  _initMarkersCluster() {
    this.markersCluster = new MarkerClusterer({
      map: this.googleMap,
      markers: this.markers.map(data => data.marker),
      renderer: this.customRenderer,
    });
  }

  _refreshMarkersCluster() {
    // Supprimer l'ancien cluster si il existe
    if (this.markersCluster) {
      this.markersCluster.clearMarkers(); // Supprimer tous les marqueurs du cluster
    }
    this.markersCluster = new MarkerClusterer({
      map: this.googleMap,
      markers: this.markers.map(data => data.marker),//this.markers.filter(data => data.marker.map !== null).map(data => data.marker),
      renderer: this.customRenderer,
    });
  }


  _filters() {
    const searchButton = document.querySelector('.archive-lieux__search') as HTMLButtonElement;

    searchButton?.addEventListener('click', () => {

      const selectedType = (document.getElementById('select-type') as HTMLSelectElement).value;
      const selectedCategory = (document.getElementById('select-category') as HTMLSelectElement).value;
      const selectedCity = (document.getElementById('select-city') as HTMLSelectElement).value;

      this.markers.forEach((data) => {
        const markerTypes = data.types || [];
        const markerCategories = data.categories || [];
        const markerCity = data.city || '';

        // Vérifier si le marqueur correspond aux critères de filtrage
        const show =
          (selectedType === '' || markerTypes.includes(selectedType)) &&
          (selectedCategory === '' || markerCategories.includes(selectedCategory)) &&
          (selectedCity === '' || markerCity === selectedCity);

        // Si le marqueur doit être affiché, on le réaffiche sur la carte
        if (show) {
          data.marker.map = this.googleMap;
        } else {
          // Sinon on le cache
          data.marker.map = null;
        }
      });
      // Centrer la carte
      this._centerMap();
    });

  }

  _reset() {
    const resetButton = document.querySelector('.archive-lieux__reset') as HTMLButtonElement;
    const searchButton = document.querySelector('.archive-lieux__search') as HTMLButtonElement;

    resetButton.addEventListener('click', () => {
      searchButton.click();
    });
  }
}

export const blockArchiveLieux = new BlockArchiveLieux(); 
